import { render, staticRenderFns } from "./PorcentajesGeneral.vue?vue&type=template&id=8923265e"
import script from "./PorcentajesGeneral.vue?vue&type=script&lang=js"
export * from "./PorcentajesGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports